/*
 * Assign Messages
 *
 * This contains all the text for the Asign component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    allYears: {
        id: 'app.components.Assign.allYears',
        defaultMessage: 'All years'
    }

});



// WEBPACK FOOTER //
// ./app/components/assign/messages.js